// src/store/useAuthStore.ts
import { create } from "zustand";

interface AuthState {
  isAuthenticated: boolean;
  user: any | null;
  login: (user: any) => void;
  logout: () => void;
  checkAuth: () => void;
}

const useAuthStore = create<AuthState>((set: any) => ({
  isAuthenticated: false,
  user: null,

  login: (user: any) => {
    set({ isAuthenticated: true, user });
    localStorage.setItem("user", JSON.stringify(user));
  },

  logout: () => {
    set({ isAuthenticated: false, user: null });
    localStorage.removeItem("user");
  },

  checkAuth: () => {
    const user = localStorage.getItem("user");
    if (user) {
      set({ isAuthenticated: true, user: JSON.parse(user) });
    }
  },
}));

export default useAuthStore;
